import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

import { ProfilePrimaryCapabilityBadgeComponent } from "./profile-primary-capability-badge.component";

@NgModule({
  declarations: [ProfilePrimaryCapabilityBadgeComponent],
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  exports: [ProfilePrimaryCapabilityBadgeComponent],
})
export class ProfilePrimaryCapabilityBadgeModule {}
